import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Form } from "antd";
import * as S from "../searchFilter/styled/index.styled";

interface ISearchFilter {
  placeholder: string;
  numbersTypedCharacters: number;
  updateFilter: (ev) => void;
  changeFieldValue: (ev, value) => void;
}

const SearchFilter = ({ placeholder, updateFilter, changeFieldValue, numbersTypedCharacters }: ISearchFilter): JSX.Element => {
  const [form] = Form.useForm();

  const isValidSize = (value) => value.length >= numbersTypedCharacters;
  const onSearch = (value, event) => {
    event.preventDefault();
    if (!value) {
      updateFilter(null);
      return;
    }
    if (!isValidSize(value)) {
      return;
    }
    const strFilter = value;
    changeFieldValue("pageIndex", 1);
    updateFilter(strFilter);
  };

  return (
    <Form layout="vertical" form={form}>
      <Form.Item>
        <S.SearchInput
          placeholder={placeholder}
          allowClear
          size="large"
          onSearch={onSearch}
          onChange={(e) => onSearch(e.target.value, e)}
          data-testid="search-input"
          suffix={<SearchOutlined />}
        />
      </Form.Item>
    </Form>
  );
};
export default SearchFilter;
